import { useEffect, useState } from 'react';
import type { Session } from '@supabase/supabase-js';

import { getSession, onAuthStateChange } from '../api/auth.api';

interface SessionState {
  session: Session | null;
  /** Verdadeiro só durante a checagem inicial — troca de sessão depois disso
   *  (login, logout, refresh) atualiza `session` sem re-suspender a tela. */
  isLoading: boolean;
}

/** Sessão bruta do Supabase Auth. Para pessoa + papéis, use `useCurrentUser`. */
export function useSession(): SessionState {
  const [state, setState] = useState<SessionState>({ session: null, isLoading: true });

  useEffect(() => {
    let active = true;

    getSession()
      .then((session) => {
        if (active) setState({ session, isLoading: false });
      })
      .catch(() => {
        if (active) setState({ session: null, isLoading: false });
      });

    const unsubscribe = onAuthStateChange((session) => {
      if (active) setState({ session, isLoading: false });
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return state;
}
